<template>
    <div class="options-container">
        <ul>
            <li v-for="pokemon in pokemons"
            :key="pokemon.id"
            @click="$emit('selection', pokemon.id)">
            {{ pokemon.name }}
            </li>
        </ul>
    </div>
</template>


<script>
export default {
    props: {
        pokemons: {
            type: Array,
            required: true,
        }
    },
    methods: {

    }
}
</script>


<style scoped>


.options-container {
    background-color: aquamarine;
    margin: 20px;
    margin-top: 30px;
    
    ul {
        margin: auto;
        float: left;
        left: 18%;
        list-style-type: none;
        width: 100%;
        position: relative;
    }
    li {
        background-color: white;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        cursor: pointer;
        margin: 10px;
        width: 250px;
    }
    
    li:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }
}
</style>